var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmoothie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_194_1353)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_194_1353",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_194_1353",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_194_1353",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAAW9yTlQBz6J3mgAAAAFzUkdCAK7OHOkAAAKLSURBVFjDtZfdgaMgEMdTgiVYgiWkBDs4HmTI3ZMdxA7WDnY7cDvwOqAESqAEjw8jMIB7GHVeNmTlDzPzm5ncbrsPqR717aqHVDDBAguVdGYjtLQ5WQC+9PahaSlKzhKQassJWhhgYsKXOcVtykH6xNtp+6q7dz1MlNP5lPPTRgt098tC3N21wJ/mMgFKtACpLhNQoV1A3q576KgE+JUC3zrrrxSYYWGfFwqARmu4UiDA7D1mG8XnHBpwI8DxujZSH3FGickiOh61eekv+wxs1qtobVsvKna4qK236vVqju8T8sVgJk7im/I443OYHcLPdC4eY0a/0/il1n+uOiJ2GxszAqV0pAJnMqtP5lxbzmyLU89mVmqrR60aZ8ayU8dKQrvfLpXok8ofIZwSTTYmwbZL/06/f/3H5i/7iEjHJOCowPN1Pmgfdc66OxvX8YYjCUxCiJO9DxPWx6RR/83DgqcOIOBpvWFyUt1ilwT92eFkUla8HEZtlRqxQ51LrUQQC0yCj5PNMRchczvzWQedzaRSMZT6CF5MJeId+9y4bHS3YQJx026sGCnl/95PiahiYRLMVDo4sXRxMM6SqdIdkRWSEKbtXm/WOZUny4tCuGWImREQqdaZN9twgzD75/Sn0o2AIya8ZPZJcFOp/Qtk2fnXWyxBJvkkuBzQ7YWJ/tAAbGnYiPZJMAL83ekO1TOfBJUDgy0LRlYWz0HuB6Tc6Qkun96wYacnbMLy6PZBy01PR1sCT5SUmJ2qUOvJEZtr/8U/IFPT0StVC6fR9Sc8eseSgBv5Vu0FtPl275uK2oeda1NDYTIPMt/sB1hEZZBULDXG95YSVjLiSxgy9MeN3H3XV/l2n3tHP/8AWgfVJcOF3fEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothie);
export default __webpack_public_path__ + "static/media/smoothie.a2f6503f40e90f48bd2120d01ca4e809.svg";
export { ForwardRef as ReactComponent };